import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, MessageCircle, Phone } from 'lucide-react';
import styles from './Footer.module.css';
import logo from '../../assets/hirsta-logo-white.png';
import { SITE, waLink } from '../../config/site';

const COLUMNS = [
    { title: 'Product', links: [['Features', '/features'], ['Packages', '/features#packages'], ['Grow sales', '/#growth'], ['Book a demo', '/demo']] },
    { title: 'Modules', links: [['Billing', '/features#billing'], ['Memberships', '/features#memberships'], ['Appointments', '/features#appointments'], ['Staff and payroll', '/features#staff']] },
];

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.brandCol}>
                    <img src={logo} alt="Hirsta" className={styles.logo} />
                    <p>Salon software for billing, memberships, packages, appointments, staff and WhatsApp marketing.</p>
                    <a href={SITE.appUrl} target="_blank" rel="noreferrer" className={styles.app}>{SITE.appUrl.replace('https://', '')}</a>
                </div>
                {COLUMNS.map((col) => (
                    <div key={col.title} className={styles.col}>
                        <h4>{col.title}</h4>
                        {col.links.map(([label, to]) => <Link key={label} to={to}>{label}</Link>)}
                    </div>
                ))}
                <div className={styles.col}>
                    <h4>Talk to us</h4>
                    <a href={`tel:${SITE.phone.replace(/\s/g, '')}`}><Phone size={13} /> {SITE.phone}</a>
                    <a href={waLink('Hi, I would like a demo of Hirsta.')} target="_blank" rel="noreferrer"><MessageCircle size={13} /> WhatsApp us</a>
                    <a href={`mailto:${SITE.email}`}><Mail size={13} /> {SITE.email}</a>
                    <span><MapPin size={13} /> {SITE.city}</span>
                </div>
            </div>
            <div className={styles.bottom}>
                <span>© {new Date().getFullYear()} Hirsta. All rights reserved.</span>
                <span>Made for salons in India</span>
            </div>
        </footer>
    );
}
